import { render, staticRenderFns } from "./major-group.vue?vue&type=template&id=46ac033a&scoped=true"
import script from "./major-group.vue?vue&type=script&lang=js"
export * from "./major-group.vue?vue&type=script&lang=js"
import style0 from "./major-group.vue?vue&type=style&index=0&id=46ac033a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac033a",
  null
  
)

export default component.exports